import ClipboardJS from 'clipboard';

import {autobind} from 'core-decorators';

import {Component} from 'inferno';

import {Tooltip} from './Tooltip';


export class Copybox extends Component<jsx.Props, jsx.State> {
    inputElement: HTMLInputElement|null;
    clipboard?: ClipboardJS;
    activateTooltip?: (...args: any[]) => void;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.inputElement = null;
    }
    componentDidMount() {
        this.clipboard = new ClipboardJS(this.inputElement);
        this.clipboard.on('success', this.activateTooltip);

        if (this.props.autoActivate) {
            this.inputElement?.click();
        }
    }
    componentWillUnmount() {
        this.clipboard?.destroy();
    }
    @autobind
    handleClick(event: Event) {
        this.selectAll();
        window.gaEvent({
            category: 'Copybox',
            action: 'click',
            label: this.props.value,
        });
    }
    selectAll() {
        this.inputElement?.select();
    }
    @autobind
    setInputElement(element: HTMLInputElement|null) {
        this.inputElement = element;
    }
    render() {
        const gettextSub = this.context.gtService.gettextSub;
        const {className, ...props} = this.props;

        return (
            <div className={`Copybox ${className}`.trim()}>
                <Tooltip
                    msg={gettextSub('Copied to clipboard')}
                    addTooltipActivationCallback={(callback) => {
                        this.activateTooltip = callback;
                    }}
                />
                <input
                    type="text"
                    readOnly={true}
                    onClick={this.handleClick}
                    ref={this.setInputElement}
                    data-clipboard-text={props.value}
                    {...props}
                />
            </div>
        );
    }
}
